import React from "react";
import Reveal from "@/components/Reveal";
import { CalendarClock, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PLANS } from "@/data/band";

const go = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Tour() {
  return (
    <section id="tour" data-testid="tour" className="relative py-24 md:py-32 bg-[#0a0a0b] overflow-hidden">
      <div className="absolute -top-40 -right-40 w-[480px] h-[480px] rounded-full bg-[var(--sb-magenta)]/10 blur-3xl" aria-hidden />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative z-10">
        <Reveal>
          <div className="max-w-2xl">
            <span className="text-sm font-bold uppercase tracking-[0.25em] text-[var(--sb-red)]">What's Next</span>
            <h2 className="font-display text-5xl md:text-7xl text-white mt-3 leading-[0.95]">
              2025 — Set To Be <span className="sb-gradient-text">Unforgettable</span>
            </h2>
            <p className="text-white/65 mt-4 text-lg">
              New music, big festivals and an extensive tour. Join the list and you'll be first to know
              the moment dates drop.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {PLANS.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.1}>
              <div
                data-testid={`plan-${p.id}`}
                className="group h-full rounded-2xl border border-white/10 bg-gradient-to-br from-white/[0.06] to-transparent p-7 hover:border-[var(--sb-red)]/50 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="text-xs font-bold uppercase tracking-[0.2em] text-[var(--sb-amber)]">{p.eyebrow}</div>
                <h3 className="font-display text-3xl text-white mt-2">{p.title}</h3>
                <p className="text-white/65 mt-3 leading-relaxed">{p.body}</p>
                <div className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-white/80 border border-white/15 rounded-full px-3 py-1.5">
                  <CalendarClock size={15} className="text-[var(--sb-red)]" /> {p.status}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-12 rounded-2xl border border-white/10 bg-[#141416] p-8 md:p-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div>
              <h3 className="font-display text-3xl md:text-4xl text-white">Never miss a show</h3>
              <p className="text-white/60 mt-2">Tour dates and new releases, straight to your inbox.</p>
            </div>
            <Button
              data-testid="tour-notify-btn"
              onClick={() => go("contact")}
              className="h-13 px-7 py-6 bg-[var(--sb-red)] hover:bg-[#ff4545] text-white font-bold uppercase tracking-wider rounded-full group whitespace-nowrap"
            >
              Join the List
              <ArrowRight size={18} className="ml-1 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
